import { AccordionPanel } from '../components/BenefitsAccordionTable/BenefitsAccordionTable';

export const benefitsAccordionTableContent: AccordionPanel[] = [
  {
    title: 'Breakdown coverage',
    description: "We'll protect your product after the manufacturer's warranty ends.",
    currentWarranty: 'covered',
  },
  {
    title: 'Accidental damage coverage (includes accessories)',
    description: "Coverage for life's mishaps.",
    currentWarranty: 'notCovered',
  },
  {
    title: "A replacement if it can't be fixed",
    description: "If we can't fix it, we'll replace it (includes delivery of your new product).",
    currentWarranty: 'partial',
    additionalContent: 'Only for breakdowns',
  },
  {
    title: 'Unlimited repairs',
    description: 'Get unlimited repairs by authorized technicians, using factory-certified parts.',
    currentWarranty: 'partial',
    additionalContent: 'Only for breakdowns',
  },
  {
    title: 'No hidden costs',
    description: 'Zero deductibles on parts and labor.',
    currentWarranty: 'partial',
    additionalContent: 'Only for breakdowns',
  },
];
